module.exports = __webpack_public_path__ + "static/img/img-home-jzg-03.36327d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-home-jzg-03.png
// module id = ERAS
// module chunks = 1